export const CHANGE_ARTICLE_LANGUAGE = "CHANGE_ARTICLE_LANGUAGE"

export const changeArticleLanguage = language => {
  return {
    type: CHANGE_ARTICLE_LANGUAGE,
    payload: language,
  }
}
